import { PieChart, Pie, Cell } from "recharts";


const COLORS = ["#F2A93B", "#3F7D20"];

const GenderDonut = ({ data = [] }) => {
  const chartData = data.length > 0 ? data : [{ name: "No data", value: 1 }];
  const hasData = data.length > 0;

  return (
    <div className="flex justify-center">
      <PieChart width={220} height={220}>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={hasData ? 3 : 0}
          dataKey="value"
        >
          {chartData.map((_, index) => (
            <Cell key={index} fill={hasData ? COLORS[index % COLORS.length] : "#e5e7eb"} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
};

export default GenderDonut;
